var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticStyle: { top: "30px" },
      attrs: {
        visible: _vm.visible,
        width: 1000,
        title: "隐私政策",
        destroyOnClose: "",
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleOk },
    },
    [
      _c("template", { slot: "default" }, [
        _c("div", { staticClass: "content" }, [
          _vm._v(" 版本： 1.0"),
          _c("br"),
          _vm._v(" 生效日： 2025年01月01日"),
          _c("br"),
          _c("div", [_vm._v("特别提示：")]),
          _vm._v(
            " 本协议所称“您”包含拟注册及已注册为网上服务平台 “易仓科技软件”系统（网址： "
          ),
          _c("u", { staticStyle: { display: "inline" } }, [
            _vm._v(
              " www.sellerwell.com ，上述软件系统及网址以下合称“易仓科技平台”"
            ),
          ]),
          _vm._v("）的用户，以及用户委派的相关人员。 "),
          _c("br"),
          _vm._v(" 本协议所称“我们”指易仓科技软件服务的提供者。"),
          _c("br"),
          _vm._v(
            " 感谢您的信任，我们特此承诺将按法律法规要求，采取相应的隐私信息安全防护措施。"
          ),
          _c("br"),
          _vm._v(" 据此，我们制定本《隐私政策》（下称“本政策”）并提醒您："),
          _c("br"),
          _c("u", [
            _vm._v(
              "1.如您不同意本协议的，请停止在易仓科技平台的注册、浏览，停止使用易仓科技平台涉及的软件及服务、其他相关事宜，"
            ),
            _c("span", { staticClass: "border_red color_red" }, [
              _vm._v("否则，视为您同意并接收本协议的相关约定。"),
            ]),
          ]),
          _c("br"),
          _c("u", [
            _vm._v(
              "2.本协议适用于易仓科技平台提供的所有产品和服务，均不包括第三方为您提供的服务，如您使用第三方服务的，则遵照第三方的相关约定，易仓科技平台不就第三方提供的服务承担隐私保护责任。"
            ),
          ]),
          _c("span", { staticStyle: { color: "red" } }, [
            _vm._v(
              "在本协议中约定事项、加粗、下划线、红色等方式显著标识的文字，请您着重阅读，慎重考虑同意后再点击注册。"
            ),
          ]),
          _c("h3", [_vm._v("第一部分 定义")]),
          _vm._v(" 易仓科技软件系统：指"),
          _c("u", [_vm._v("易仓科技平台")]),
          _vm._v(
            "网址提供的线上【易仓科技软件】系统（以下简称“易仓科技软件”），"
          ),
          _c("u", [_vm._v("具体以易仓科技平台提供的系统为准")]),
          _vm._v(
            "。您根据易仓科技平台指示，依据您实际所需选择及采购该软件系统的普通许可使用权限，生成订单后，您对该订单进行按时足额付费，且经易仓科技平台后台人员审核通过后，您（该订单付费的注册用户）才享有就已付费且通过审核的软件系统相应的软件普通许可使用权限及服务，上述具体以您下的订单内容及易仓科技平台规定为准，软件系统的普通许可使用权限非永久性。"
          ),
          _c("br"),
          _vm._v(" 易仓科技软件系统服务提供者："),
          _c("u", [
            _vm._v(
              "指【深圳市易仓科技】有限公司（以下简称“公司”或“易仓科技公司”），公司管理易仓科技平台"
            ),
          ]),
          _vm._v("。"),
          _c("br"),
          _vm._v(
            " 个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。"
          ),
          _c("br"),
          _vm._v(
            " 个人敏感信息：指一旦非法提供、泄露、或滥用则可能危害人身和财产安全，导致个人身心健康及名誉受到歧视、损害等的个人信息，主要指个人身份证件号码、个人健康生理信息、网络身份标识信息、个人生物识别信息、个人财产信息等。"
          ),
          _c("br"),
          _c("h3", [_vm._v("第二部分 隐私权政策")]),
          _vm._v(" 一、我们如何收集和使用您的信息。"),
          _c("br"),
          _c("u", [_vm._v("您理解并同意：")]),
          _c("br"),
          _c("u", [
            _vm._v(
              "易仓科技平台为您提供产品及/或服务时，我们可能会收集、保存和使用下列与您有关的信息。如您拒绝提供，您将无法正常使用 易仓科技平台的产品及/或服务，相关附加功能或无法达到我们拟达到的功能效果。"
            ),
          ]),
          _c("br"),
          _vm._v(
            " 我们会为实现本隐私政策约定的下述的各项功能，收集和使用您的个人信息："
          ),
          _c("br"),
          _c("h3", [_vm._v("（一） 用户注册")]),
          _c("h3", [_vm._v("1、用户注册")]),
          _vm._v(" 我们通过"),
          _c("u", [_vm._v("易仓科技平台")]),
          _vm._v("账户为您提供产品及/或服务。为注册成为"),
          _c("u", [_vm._v("易仓科技平台")]),
          _vm._v("用户并拥有相应的账户才能使用我们的"),
          _c("u", [_vm._v("易仓科技平台")]),
          _vm._v(" 服务，您需要提供以下信息才能创建账户："),
          _c("span", { staticClass: "border_red color_red" }, [
            _vm._v(
              "手机号码、公司名称、邮箱、公司营业执照及易仓科技平台所需的其他资料"
            ),
          ]),
          _vm._v("。"),
          _c("br"),
          _vm._v(" 2、"),
          _c("u", [
            _vm._v(
              "账户信息展示：如果您已完成注册易仓科技平台账户的，您同意并授权我们可能会在易 仓平台服务中显示您的上述个人信息（认证是否通过），以及您在易仓科技平台上相关行为如：展示您的个人资料、优惠、相关权益、采购订单、销售订单、其他交易订单、授权信息、所属企业等。"
            ),
          ]),
          _c("br"),
          _c("h3", [_vm._v("（二）下单")]),
          _c("u", [
            _vm._v(
              "如您使用易仓科技平台进行采购您所需的易仓科技软件系统的普通使用许可权限及/或易仓科技平台服务时，易仓科技平台会自动为您创建上述采购订单及付款金额、付款时间，您需依据下单要求提供订单及服务有关的信息。 "
            ),
          ]),
          _vm._v(
            "以上所有信息将构成 “订单信息”，我们将使用订单信息来进行您的身份核验、确定交易、支付结算、系统部署、为您查询订单以及提供客服咨询与售后服务。"
          ),
          _c("u", [
            _vm._v(
              "如订单信息中涉及未成年人个人信息的，您应提前征得该未成年人的监护人的同意，否则您应自行承担相应的责任。"
            ),
          ]),
          _vm._v(
            "如您没有为订单及时足额付款，则您不能享有订单所约定的软件系统的普通许可权限及易仓科技平台所提供的其他服务。"
          ),
          _c("br"),
          _c("h3", [_vm._v("（三）完成支付")]),
          _vm._v(
            " 为完成订单支付，您可以选择易仓科技平台提供的与易仓科技平台合作的第三方支付机构（包括微信支付及支付宝、银联等支付机构，以下称“支付机构”）所提供的支付服务。 "
          ),
          _c("u", [
            _vm._v(
              "我们会将您的易仓科技平台账户会员名、对应的支付机构账户名、订单支付相关信息、订单安全相关 设备信息及其他反洗钱法律要求的必要信息与支付机构共享。"
            ),
          ]),
          _c("br"),
          _c("h3", [_vm._v("（四）交付软件普通授权许可使用权限或商品或服务")]),
          _vm._v(
            " 对于您已足额按时付费，且经易仓科技平台审核通过的订单，您享有在易仓科技平台普通许可范围内进行使用该订单约定的软件系统的权限及享有相应的易仓科技平台服务。易仓科技软件系统将为商业用户提供易仓科技软件系统的使用服务，包括订单处理、采购管理、供货商管理 和仓储管理和数据报告等网络应用服务，商户可以通过易仓科技软件系统有效的解决日常电商运营工作，具体以您采购的订单所对应的软件系统功能为准。上述过程中可能会涉及到对您提供的隐私信息的采集、处理、存储等事宜。"
          ),
          _c("br"),
          _c("h3", [_vm._v("（五） 客服及争议处理")]),
          _vm._v(
            " 为了保障您的账户及系统安全，您同意在订单交易过程及售后、争议纠纷处理时， "
          ),
          _c("u", [
            _vm._v(
              "我们需要您主动提供相关的个人及/或企业信息进行核验您的用户身份。我们会根据需要，保存您与我们的通话、通信记录等内容，并使用您的账号信息和订单信息。"
            ),
          ]),
          _c("br"),
          _c("h3", [_vm._v("（六）合法授权")]),
          _c("u", [
            _vm._v(
              "1、您在使用易仓科技平台时提供的信息应取得合法授权，且对个人信息来源的合法性和合规性作出承诺。如您为取得授权的，信息所有权人有权要求易仓科技平台进行更正或删除您披露的相关未取得授权信息。如您未取得授权的，相关责任将由您承担，易仓科技平台不承担上述责任及风险。"
            ),
          ]),
          _c("br"),
          _vm._v(" 2、无须授权信息"),
          _c("br"),
          _c("u", [
            _vm._v(
              "您充分知晓，并同意我们在以下情形中收集、使用个人信息无需征得您的授权同意："
            ),
          ]),
          _c("br"),
          _vm._v(" 2.1与国家安全、国防安全有关的；"),
          _c("br"),
          _vm._v(" 2.2与公共安全、公共卫生、重大公共利益有关的；"),
          _c("br"),
          _vm._v(
            " 2.3与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的；"
          ),
          _c("br"),
          _vm._v(
            " 2.4出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；"
          ),
          _c("br"),
          _vm._v(" 2.5您自行向社会公众公开的个人信息；"),
          _c("br"),
          _vm._v(
            " 2.6从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。"
          ),
          _c("br"),
          _vm._v(" 2.7根据与您签订和履行相关协议或其他书面文件所必需的；"),
          _c("br"),
          _vm._v(
            " 2.8用于维护所提供的产品及/或服务的安全稳定运行所必需的，例如发现、处置产品及/或服务的故障；"
          ),
          _c("br"),
          _vm._v(" 2.9为合法的新闻报道所必需的；"),
          _c("br"),
          _vm._v(
            " 2.10学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；"
          ),
          _c("br"),
          _vm._v(" 2.11法律法规规定的其他情形。"),
          _c("br"),
          _vm._v(
            " 请您了解并同意，根据适用的法律，在收集您的个人信息后，我们将通过技术手段处理数据进行去标识化，致使信息将无法识别主体，据此，我们 有权使用已经去标识化的信息，并对用户数据库进行分析及商业化的利用，"
          ),
          _c("u", [
            _vm._v("则此类处理后数据的使用无需另行向您通知并征得您的同意。"),
          ]),
          _c("br"),
          _c("h3", [_vm._v("二、数据访问及数据管理")]),
          _vm._v(
            " 1.您同意并有义务按照本协议约定向易仓科技公司提供履行服务所需的所有数据。您的亚马逊平台注册的帐户(“亚马逊帐户”)将授权易仓科技软件以获取相关数据及报表，您同意并确保易仓科技平台管理者被授予此目的所需的所有访问权限。您知悉并同意亚马逊平台相关政策，依据亚马逊对个人身份信息保留政策要求，易仓科技平台对在您的买家自订单发货之日起28天后， 将自动删除买家中涉及的个人身份信息，并且不做离线备份，如因此造成您损失的，您同意豁免易仓科技公司责任。"
          ),
          _c("br"),
          _vm._v(
            " 2.您承诺并确保所提供、使用的数据或从易仓科技软件获取的数据、信息，均不违反法律法规规定，且不侵犯第三方的权利。如发生上述违规行为的，易仓科技公司可能会中止提供服务或终止您访问易仓科技软件。如上述造成易仓科技公司损失的，您应赔偿易仓科技公司因您违反上述约定而造成的任何损害，包括因实现上述债权而产生的费用，包括但不限于公证费、律师费、鉴定费、差旅费等。"
          ),
          _c("br"),
          _vm._v(
            " 3.您授予易仓科技公司使用、分析因您使用易仓科技软件或您授权的亚马逊帐户来收集和分析与您直接或没有直接关系的数据或其他事宜所产生的数据。"
          ),
          _c("br"),
          _vm._v(
            " 4.您知悉并理解依据亚马逊的数据保护政策规定，易仓科技公司有权为易仓科技软件及易仓科技平台设立数据处理及隐私政策进行管理和保护信息。易仓科技公司应保存能够访问PII的软件和实物资产(如计算机、移动设备)的库存，并定期进行更新。易仓科技公司有权记录维护 数据处理活动，必须建立并遵守客户同意的隐私政策和数据访问权。乙方同意甲方享有上述权限。"
          ),
          _c("br"),
          _vm._v(" 5."),
          _c("span", { staticClass: "color_red" }, [
            _vm._v(
              "易仓科技公司有权每年定期对您使用或管理易仓科技软件涉及的数据分析、使用、传输等事宜进行监督及审查，如发现您违反本协议约定使用数据或其他损害第三方合法权益事宜的，易仓科技公司有权中止为乙方提供服务，并要求您整改直至满足法律法规及易仓科技公司要求，如您未能整改的，易仓科技公司有权终止为您提供服务"
            ),
          ]),
          _vm._v("。"),
          _c("br"),
          _vm._v(" 6.要求删除"),
          _c("br"),
          _vm._v(
            " 如易仓科技公司收到亚马逊通知并要求删除亚马逊信息的，您理解并同意甲方自行立即永久且安全地删除相关信息。甲方还必须在亚马逊发出通知后的90天内永久安全地删除所有实时的（在线或网络可访问的）亚马逊信息实例。"
          ),
          _c("br"),
          _c("h3", [_vm._v("三、我们如何使用Cookie和同类技术")]),
          _vm._v(" （一）Cookie"),
          _c("br"),
          _vm._v(
            " 为确保系统正常运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的计算机或移动设备上发送一个或多个名为Cookies的小数据文件 （统称“Cookie”）。借助于 Cookie，系统能够存储您的偏好或购物车内的商品等数据，实现您个性化需求及获得更轻松的访问体验。"
          ),
          _c("br"),
          _c("u", [
            _vm._v(
              "如您不同意上述事宜的，您可根据自己的偏好管理或删除 Cookies。"
            ),
          ]),
          _vm._v(
            "如果您这么做，在某些情况下可能会影响您访问我们的系统安全性及便捷性。"
          ),
          _c("br"),
          _c("h3", [_vm._v("四、我们如何共享、转让、公开披露您的信息")]),
          _vm._v(
            " 除以下任一情况外，我们不会与易仓科技平台服务提供者以外的第三方共享、披露、转让您的个人信息："
          ),
          _c("br"),
          _vm._v(" 1.依据本协议约定所从事事宜；"),
          _c("br"),
          _vm._v(" 2.您事先明确的同意或授权；"),
          _c("br"),
          _vm._v(" 3.依据法律法规、行政或司法要求提供；"),
          _c("br"),
          _vm._v(
            " 4.在法律法规允许的范围内，为维护您或易仓科技软件系统及/或其关联方、合作方的合法权益；"
          ),
          _c("br"),
          _vm._v(" 5.维护公共利益、社会公序良俗；"),
          _c("br"),
          _vm._v(" 6.为了实现您的订单的产品与/或服务的完成；"),
          _c("br"),
          _vm._v(" 7.应您需求为您处理相关事务；"),
          _c("br"),
          _vm._v(" 8.符合与您签署的相关协议、文件约定；"),
          _c("br"),
          _vm._v(" 9.基于学术研究、公益事业而使用。"),
          _c("br"),
          _vm._v(" 特此提示："),
          _c("br"),
          _vm._v(
            " 1.除本政策约定、获得您明确同意、易仓科技平台发生合并、收购、破产、清算等上述任一情况发生外，我们不会将您的个人信息转让给任何第三方。"
          ),
          _c("br"),
          _vm._v(" 2.请您理解并知悉，"),
          _c("u", [
            _vm._v(
              "如我们对个人信息采取技术处理使得接收方无法重新识别个人的，则我们处理后数据的共享、公开披露、转让均无需通知您，并无须征得您的同意"
            ),
          ]),
          _vm._v("。"),
          _c("br"),
          _c("h3", [_vm._v("五、我们如何保护您的信息")]),
          _vm._v(
            " （一）我们将采取符合法律法规要求及行业标准设置安全防护措施防止个人信息遭到侵害。我们会不断加强技术用于提高个人信息防护的安全性；建立访问控制机制，内部加强个人信息安全防护培训。"
          ),
          _c("br"),
          _vm._v(
            " （二）互联网并非绝对安全的环境，您在使用电子邮件、通讯、社交软件等与其他用户的交流时，建议您做好您的个人信息安全防护措施。"
          ),
          _c("br"),
          _vm._v(
            " （三）请您慎重考虑从事自愿共享甚至公开分享的信息，上述可能会涉及发布或公开披露您或他人的个人信息。"
          ),
          _c("br"),
          _vm._v(
            " （四）如发生个人信息安全事件的，我们会依据法律法规要求处理，并向监管部门上报个人信息安全事件的处置情况。"
          ),
          _c("br"),
          _vm._v(" 特别提示："),
          _c("u", [
            _vm._v(
              "如您发现您的个人信息、您的账户及密码发生泄露的，请您立即通过本隐私政策中约定的联系方式及时联络我们，以便我们采取相应措施。"
            ),
          ]),
          _c("br"),
          _c("h3", [_vm._v("六、您如何管理您的信息")]),
          _vm._v(" 您可以通过以下方式访问及管理您的信息："),
          _c("br"),
          _vm._v(" （一）除法律法规规定、政策要求、"),
          _c("u", [_vm._v("易仓科技平台")]),
          _vm._v("管理要求外，您同意按"),
          _c("u", [_vm._v("易仓科技平台")]),
          _vm._v("公示或注册要求提供您 的信息，如信息有更新或错误的，您可在"),
          _c("u", [_vm._v("易仓科技平台")]),
          _vm._v("按以下路径查询、更正和补充您的信息。"),
          _c("br"),
          _vm._v(" 【"),
          _c("u", [_vm._v("易仓科技平台->个人中心->基本信息")]),
          _vm._v("】。如您有疑问的，可以与易仓科技平台联系。"),
          _c("br"),
          _vm._v(
            " （二）如易仓科技平台在处理您个人信息时发生以下任一事宜的，您可以向我们提出删除个人信息："
          ),
          _c("br"),
          _vm._v(" 1、违反法律法规；"),
          _c("br"),
          _vm._v(" 2、违反与您的相关协议约定；"),
          _c("br"),
          _vm._v(" 3、未征得您的明确同意/授权；"),
          _c("br"),
          _vm._v(" 4、终止为您提供产品/服务；"),
          _c("br"),
          _vm._v(
            " 如您提出上述请求时，请提出相应的依据，我们在核实后，会跟您联系办理相应手续，您同意配合我们确认个人信息主体资格及办理信息删除手续。"
          ),
          _c("br"),
          _c("u", [
            _vm._v(
              "您理解并同意，我们会积极响应您的删除请求，但因法律法规规定及安全技术手段等原因，我们可能无法立即从备份系统中删除相应的信息，我们将对拟删除的信息进行安全隔离直或实现匿名去除标识化。"
            ),
          ]),
          _c("br"),
          _vm._v(" （三）改变授权/同意"),
          _c("br"),
          _vm._v(
            " 如您需要改变隐私授权的，您可以通过注销账户、在易仓科技平台办理删除信息或关闭设备功能或在易仓科技平台进行隐私设置等方式改变您授权。"
          ),
          _c("br"),
          _vm._v(
            " 请您理解并同意，由于易仓科技平台提供的业务及服务时，需要收集、运用您的个人信息才能得以完成，当您撤回同意/授权后，我们将不再处理相应的个人信息，也无法为您提供相应的服务，"
          ),
          _c("u", [
            _vm._v(
              "如您收回授权/同意的决定，基于您此前已授权/同意而进行的个人信息处理将不会受到影响。"
            ),
          ]),
          _c("br"),
          _vm._v(" （四）注销您的账户"),
          _c("br"),
          _vm._v(" 您可以通过以下方式申请注销您的账户："),
          _c("br"),
          _vm._v(" 您理解并同意，在您主动注销账户并完成"),
          _c("u", [_vm._v("易仓科技平台")]),
          _vm._v(
            "的相关审核之后，我们将停止为您提供产品/服务，我们将删除您的个人信息，"
          ),
          _c("u", [
            _vm._v(
              "但因法律法规规定及安 全技术手段等原因，我们可能无法立即从备份系统中删除相应的信息，我们将对拟删除的信息进行安全隔离直或实现匿名去除标识化。"
            ),
          ]),
          _c("br"),
          _vm._v(" （五）响应您的上述请求"),
          _c("br"),
          _c("u", [
            _vm._v(
              "为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。您均可以发送电子邮件至【ec-mkt@eccang.com】或通过本隐私政策中的其他方式 与我们联系。"
            ),
          ]),
          _vm._v(
            "为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份，我们将在收到您反馈并验证您的身份之日起15天内答复您的请求。"
          ),
          _c("br"),
          _vm._v(
            " 我们原则上对于您合理的请求不收取费用，但超出合理限度、违反法律法规、多次重复的请求，我们将酌情收取一定费用。对于与您不直接关联、无端重复的身份或个人信息，或者需要过多技按照法律法规要求，如您请求删除的信息涉及在以下情形的，我们将无法响应您的请求："
          ),
          _c("br"),
          _vm._v(
            " 1、与国家安全、国防安全、公共安全、公共卫生、重大公共利益有关的；"
          ),
          _c("br"),
          _vm._v(" 2、与犯罪侦查、起诉、审判、仲裁和执行判决等有关的；"),
          _c("br"),
          _vm._v(" 3、有充分证据表明个人信息主体存在主观恶意或滥用权利的；"),
          _c("br"),
          _vm._v(
            " 4、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。"
          ),
          _c("br"),
          _c("h3", [_vm._v("七、未成年人的个人信息保护")]),
          _vm._v(" 易仓科技平台非常重视对未成年人个人信息的保护。"),
          _c("u", [_vm._v("在电子商务活动中我们推定您具有相应的民事行为能力")]),
          _vm._v(
            "。若您是未成年人的，则请您 在使用我们的产品与/或服务前，应事先取得您监护人的同意。"
          ),
          _c("br"),
          _vm._v(
            " 我们将依据国家相关法律法规的规定保护未成年人的个人信息。我们不会主动直接向未成年人收集其个人信息，并仅对于经监护人同意而收集未成年人 个人信息，且只会在受到法律法规规定范围内，在监护人同意或者保护未成年人所必要的情况下使用、分享、披露、转让此信息。"
          ),
          _c("br"),
          _c("u", [
            _vm._v(
              "如果有事实证明未成年人并未取得监护人同意的情况下注册使用了我们的产品与/或服务，我们会与相关监护人协商，并设法尽快删除相关个人信息。 如您对您所监护的未成年人的个人信息有疑问，请通过本协议约定的任何联系方式与我们联系。"
            ),
          ]),
          _c("br"),
          _c("h3", [_vm._v("八、隐私政策变更")]),
          _vm._v(
            " 由于法律法规、政策调整，我们业务模式的变化，可能导致我们的隐私政策变更。未经您明确同意，我们不会擅自限制您按照本隐私政策所应享有的权利。"
          ),
          _c("br"),
          _c("u", [
            _vm._v(
              "请您访问易仓科技平台以便及时了解最新的隐私政策。如隐私政策有变更的，我们将会在易仓科技平台 上发布对隐私权协议、政策所做的更新。对于重大变更，我们还会提供更为显著的通知。"
            ),
          ]),
          _c("br"),
          _vm._v(" 本政策所指的重大变更包括但不限于："),
          _c("br"),
          _vm._v(" 1、易仓科技平台业务、服务模式发生重大变化；"),
          _c("br"),
          _vm._v(" 2、我们在业务调整、股东层面、控制权等方面发生重大变化；"),
          _c("br"),
          _vm._v(" 3、个人信息共享、转让或公开披露的主要对象发生变化；"),
          _c("br"),
          _vm._v(" 4、您的个人信息处理方面的权利及行使方式发生重大变化；"),
          _c("br"),
          _vm._v(" 5、我们负责处理个人信息安全的联络方式发生变化；"),
          _c("br"),
          _vm._v(" 6、个人信息安全存在高风险。"),
          _c("br"),
          _c("h3", [_vm._v("九、联系我们")]),
          _vm._v(
            " 1. 如对本政策内容有任何疑问、建议、意见、投诉的，您可通过以下方式与我们联系；我们将在15天内回复您的请求："
          ),
          _c("br"),
          _vm._v(" 联系电话：【400-8199-388】；"),
          _c("br"),
          _vm._v(" 联系邮箱：【ec-mkt@eccang.com】；"),
          _c("br"),
          _vm._v(" 联系地址：【深圳市南山区留仙大道创智云城A6座】。"),
          _c("br"),
          _vm._v(
            " 如果您对我们的回复不满意，欢迎与我们多家交流，如您认为我们的个人信息处理行为损害了您的合法权益且有相关证据的， "
          ),
          _c("u", [
            _vm._v("您还可以通过法律途径如诉讼／仲裁等方式寻求解决方案"),
          ]),
          _vm._v("。 "),
        ]),
      ]),
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "a-button",
            {
              key: "submit",
              attrs: { type: "primary" },
              on: { click: _vm.handleOk },
            },
            [_vm._v(" 确定 ")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }